import { Author, TimelinePollResultTimelineItemType } from "@teammood/timeline";
import { ClosedRecurrencePollResults, RecurrencePollResults } from "../create-poll/create-poll.type";
import { Poll, PollType } from "../polls.type";

export class PollList {
    questions: PollListItem[];
    constructor(questions: PollListItem[]) {
        this.questions = questions;
    }
    search(term: string): PollList {
        const filteredQuestions = this.questions.filter(question => question.label.toLowerCase().includes(term.toLowerCase()))
        return new PollList(filteredQuestions);
    }
}

export class PollListItem {
    id: string;
    label: string;
    status: 'ScheduledQuestionStatus' | 'LiveQuestionStatus' | 'FinishedQuestionStatus';
    teams: string[]; 
    author?: Author;
    duration: number;
    displayAuthor: boolean = true;
    allowComments: boolean = true;
    showAllTeams?: boolean = false; // added for conditional rendering
    showTrends: boolean = false;
    recurrence: {
        frequency: string;
        enabled?: boolean;
        value: string;
    };
    occurrences: PollOccurrence[];
    availableChoices?: PollAvailableChoice[];
    itemType?: TimelinePollResultTimelineItemType;
}

export interface PollOccurrence {
    pollOccurrenceId: string;
    startDate: Date;
    endDate: Date;
    reminderDate: Date;
    isDeletable: boolean;
    teams: PollInTeam[];
    status: 'ScheduledQuestionStatus' | 'LiveQuestionStatus' | 'FinishedQuestionStatus';
}

export class PollInTeam {
    teamId: string;
    teamName: string;
    pollId: string;
    participation: number;
}


export interface PollDetailsData {
    pollAggregateId: string,
    teams: string[],
}

export interface PollTrends {
    label: string,
    itemType: TimelinePollResultTimelineItemType,
    displayAuthor: boolean,
    author?: Author,
    allResults: ClosedRecurrencePollResults | RecurrencePollResults, // or trendResults
    teams: string[],
    availableChoices: PollAvailableChoice[],
}

export interface PollAvailableChoice {
    id: string,
    label: string,
    position: number
}
